export enum ReportsItemSortField {
    PRICE_TYPE = 'PRICE_TYPE',
    ITEM_NAME = 'ITEM_NAME',
    PRODUCT_CODE = 'PRODUCT_CODE',
    PRODUCT_SKU = 'PRODUCT_SKU',
    ORIGINAL_PRICE = 'ORIGINAL_PRICE',
    INCREASED_PRICE = 'INCREASED_PRICE',
    INCREASED_DATE = 'INCREASED_DATE',

}